import { render, staticRenderFns } from "./Segnala.vue?vue&type=template&id=2c14a4b8&scoped=true&"
import script from "./Segnala.vue?vue&type=script&lang=js&"
export * from "./Segnala.vue?vue&type=script&lang=js&"
import style0 from "./Segnala.vue?vue&type=style&index=0&id=2c14a4b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14a4b8",
  null
  
)

export default component.exports